import { useEffect as f } from "react";
const c = (e) => {
  f(e, []);
};
export {
  c as default
};
//# sourceMappingURL=useEffectOnce.js.map
